import ActivityTab from "@/modules/lead-page/new/components/activity/activity-tab";
import { TrackActivityProvider } from "../../contexts/track-activity.context";
import { Track } from "../../types";
import AddTrackComment from "./add-comment";
import { ActivityScrollProvider } from "@/modules/lead-page/new/context/activity-scroll-context";
import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import useActivityTimeline from "@/modules/lead-page/new/hooks/activity-timline.hook";
import MobileFilterMenu from "@/modules/lead-page/new/components/activity/filters/mobile-filter-menu";

function PropertyActivityMobileModal({
  track,
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
  track: Track;
}) {
  const { isLoading, isFetching, count } = useActivityTimeline();

  return (
    <FullPageModal
      isOpen={open}
      onClose={onClose}
      title={`Activity (${isLoading || isFetching ? "..." : count})`}
      extraButtons={<MobileFilterMenu />}
    >
      <ActivityTab
        isHeaderCollapsed={false}
        addComment={<AddTrackComment trackUId={track.uid} />}
      />
    </FullPageModal>
  );
}

export default function PropertyActivityMobile({
  open,
  onClose,
  track,
}: {
  track: Track;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <TrackActivityProvider trackUId={track.uid}>
      <ActivityScrollProvider>
        <PropertyActivityMobileModal
          track={track}
          open={open}
          onClose={onClose}
        />
      </ActivityScrollProvider>
    </TrackActivityProvider>
  );
}
